module.exports = __webpack_public_path__ + "img/embalses.66f3c56b.png";